/** @jsxRuntime automatic */
import { loopPhase } from "./motion";
import { cn } from "./utils";

/**
 * The sheen in phase with `document.timeline`, written once as the block
 * mounts (a module function: one identity, so a render never rewrites it).
 */
function inPhase(el: HTMLDivElement | null) {
  el?.style.setProperty("--skeleton-phase", loopPhase());
}

/**
 * Loading placeholder. `--skeleton` is foreground at 7 % (white 8 % in dark), so
 * it reads on white, sunken and card surfaces in both themes. One light sweeps
 * every skeleton on screen at once (a 4 % sheen on the loop period, in phase
 * with the document's clock, `.ui-skeleton`), so a relay between skeletons
 * never restarts it; `--i` on a block delays it 60 ms per block down the
 * column. Under reduced motion it breathes. Copy the real geometry (row
 * height, grade circle, title width) so nothing jumps.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      ref={inPhase}
      aria-hidden="true"
      className={cn(
        "ui-skeleton animate-shimmer rounded-md bg-skeleton bg-[linear-gradient(90deg,transparent_0%,color-mix(in_srgb,var(--foreground)_4%,transparent)_50%,transparent_100%)] bg-[length:200%_100%]",
        className,
      )}
      {...props}
    />
  );
}
